import React, { useEffect, useRef, useState } from 'react'
import Header from '../layout/Header'
import { formatDatee } from '../../helpers/converter'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { connect, useDispatch, useSelector } from 'react-redux'
import { getApplications } from '../../actions/application/getApplications'
import { pagingApplicationNurse } from '../../actions/nurse/pagingApplicationNurse'
import { applicationNoteFullHistory } from '../../actions/nurse/applicationNoteFullHistory'
import { addNoteToApplication } from '../../actions/nurse/addNoteToApplication'
import { formatZuluTime } from '../../helpers/formatter'
import { professionsv2 } from '../../actions/v3/professions'
import { careProvidersv2 } from '../../actions/v3/careProviders'
import { editCareProviderData, resetEditCareProviderData } from '../../actions/nurse/editCareProvider'
import Swal from 'sweetalert2'

function EditCareProvider(props) {
    const dispatch = useDispatch();
    const { Id, Target } = useParams();
    const user = JSON.parse(localStorage.getItem('user'));
    const [careProviderData, setCareProviderData] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(professionsv2(Target));
    }, [dispatch]);

    useEffect(() => {
        if (props.editCareProvider.done) {
            Swal.fire({
                icon: 'success',
                title: 'Başarılı',
                text: 'Başvuru bilgileri başarıyla güncellendi'
            }).then((result) => {
                dispatch(resetEditCareProviderData());
                navigate('/nurse-dashboard');

            })
        }

    }, [props.editCareProvider])

    return (
        <div>
            <Header />
            <div className='pt-10 md:ml-64 ps-5'>
                <ol className="flex items-center whitespace-nowrap min-w-0" aria-label="Breadcrumb">

                    <li className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200" aria-current="page">
                        Başvuru notları
                    </li>
                </ol>
            </div>
            <hr className='divide-y mt-2' />
            <div className='relative mt-5 ps-5 pe-5 md:ml-64 mb-20 '> {/* mb-20, input alanı için altta yer açar */}
                <label htmlFor="hs-select-label11" class="block text-sm font-medium mb-2 dark:text-white text-start">Lütfen değiştirmek istediğiniz bölümü seçiniz</label>
                <select
                    id='hs-select-label11'
                    onChange={(e) => {
                        dispatch(careProvidersv2(e.target.value, Target));
                    }}
                    class="py-3 px-4 pe-9 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600">
                    <option selected>Lütüfen değiştirmek istediğiniz bölümü seçiniz</option>
                    {props.professionsv2.done ?
                        props.professionsv2?.professionsv2?.result?.data.map((element, index) => {
                            return (
                                <option key={index} value={element.code}>{element.professionName}</option>
                            )
                        })
                        : null}
                </select>
                {props.careProvidersv2.done ?
                    <div>
                        <label htmlFor="hs-select-label12" class="mt-5 block text-sm font-medium mb-2 dark:text-white text-start">Lütfen değiştirmek istediğiniz doktoru seçiniz</label>
                        <select
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                const selectedCareProvider = props.careProvidersv2?.careProvidersv2?.result?.data.find(element => element.careProviderId === selectedId);
                                setCareProviderData(selectedCareProvider);
                            }}
                            id='hs-select-label12' class="py-3 px-4 pe-9 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600">
                            <option selected>Lütüfen değiştirmek istediğiniz doktoru seçiniz</option>
                            {props.careProvidersv2.done ?
                                props.careProvidersv2?.careProvidersv2?.result?.data.map((element, index) => {
                                    return (
                                        <option key={index} value={element.careProviderId}>{element.fullName}</option>
                                    )
                                })
                                : null}
                        </select>
                    </div>
                    : null}
                <button
                    onClick={() => {
                        dispatch(editCareProviderData(Id, careProviderData))
                    }}
                    class="float-right mt-4 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-gray-500 text-gray-500 hover:border-gray-800 hover:text-gray-800 disabled:opacity-50 disabled:pointer-events-none dark:border-gray-400 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600">
                    Bilgileri güncelle
                </button>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps)(EditCareProvider);